import React from "react";
import { makeStyles } from "tss-react/mui";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import ClbsAppBar from "../wrapper/appBar";

const useStyles = makeStyles()({
  card: {
    minWidth: 275,
    maxWidth: "70%",
    margin: "auto",
    marginTop: "20px",
    padding: "20px",
  },
  media: {
    height: 200,
  },
});

export default function Help() {
  const { classes } = useStyles();

  return (
    <ClbsAppBar>
      <Card className={classes.card}>
        <CardMedia
          className={classes.media}
          image="/HK-pic.jpeg"
          title="Contemplative Reptile"
        />
        <CardContent>
          <Typography gutterBottom variant="h4" component="h2">
            FAQ
          </Typography>
        </CardContent>
      </Card>
    </ClbsAppBar>
  );
}
